import styled from 'styled-components'

import { getResponsiveFontSizeCSS } from 'helpers/css'

export const Instructions = styled.div``

export const Step = styled.div`
    font-size: ${getResponsiveFontSizeCSS(14, 16)};
    @media (max-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) {
        color: #fff;
        margin: 10px 0;
    }
`

/* Android Chrome Styles */

export const AndroidTroubleshoot = styled.div`
    @media only screen and (orientation: landscape) and (max-width: 992px) {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
`

export const AndroidGif = styled.img`
    width: 75%;
    margin: 10px 0px;
    border-radius: 10px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.1));

    @media only screen and (orientation: landscape) and (max-width: 992px) {
        width: 40%;
    }
`

export const AndroidGifWrapper = styled.div`
    text-align: center;
    @media only screen and (orientation: landscape) and (max-width: 992px) {
        flex-basis: 50%;
    }
`

/* Safari Styles */

export const SafariTroubleshoot = styled.div`
    @media only screen and (orientation: landscape) and (max-width: 992px) {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: row-reverse;

        & > div {
            flex-basis: 50%;
            margin: 0 10px;
        }
    }

    @media (min-width: 768px) and (max-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-around;
        ${Instructions} {
            display: flex;
            flex-direction: column;
            justify-content: center;
            flex-basis: 100%;
            margin: 0 10px;
        }
    }

    @media (min-width: 768px) and (max-width: 1366px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
        justify-content: center;
        ${Instructions} {
            flex-basis: 65%;
        }
    }
`

export const SafariGif = styled.img`
    width: 100%;
    margin: 10px 0px;
    border-radius: 10px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.1));

    @media (min-width: 0px) and (max-width: 992px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
        width: 90%;
    }

    @media (min-width: 768px) and (max-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) {
        width: 90%;
    }
`

export const SafariGifWrapper = styled.div``

/* Desktop Chrome Styles */

export const DesktopTroubleshoot = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-evenly;
`

export const DesktopGifWrapper = styled.div``

export const DesktopGif = styled.img`
    width: 50%;
    border-radius: 10px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.1));
`

/* Audio Video 404 Troubleshoot styles */

export const TroubleshootList = styled.ul`
    list-style: disc;
    font-size: ${getResponsiveFontSizeCSS(14, 16)};
    line-height: 21px;
    color: #5c5c5c;
    margin-left: 15px;
    margin-top: 10px;
    & > li {
        margin: 5px 0px;
    }

    @media (max-width: 1366px) {
        color: #f3f3f5;
    }
`

export const TroubleshootListIem = styled.li`
    ::before {
        color: #c4c4c4;
        font-weight: normal;
        display: inline-block;
        width: 0.5em;
        margin-left: -1em;
    }
`
